import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { Button, Slider } from "antd";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const COLOR = "#6366f1";

const ABSplitNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();
  const pctA = data.percentA ?? 50;
  const pctB = 100 - pctA;

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? COLOR : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 240,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      position: "relative",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color={COLOR} />
      <Handle type="target" position={Position.Left} style={{ background: COLOR }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>🎲</span>
        <strong style={{ fontSize: 13 }}>A/B Split</strong>
        <Button type="text" size="small" icon={<CopyOutlined />}
          onClick={() => data.onDuplicate?.()}
          style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />}
          onClick={() => deleteElements({ nodes: [{ id }] })}
          style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#4f46e5" }}>Path A: {pctA}%</span>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#7c3aed" }}>Path B: {pctB}%</span>
        </div>
        <Slider
          min={5} max={95}
          value={pctA}
          onChange={(v) => data.onChange?.({ ...data, percentA: v })}
          tooltip={{ formatter: (v) => `A: ${v}% / B: ${100 - v}%` }}
        />

        {/* Path A handle — top-right */}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
          <span style={{ fontSize: 10, color: "#9ca3af" }}>Drag slider to adjust split</span>
        </div>
      </div>

      {/* Named handles for each path */}
      <Handle
        type="source"
        position={Position.Right}
        id="path_a"
        style={{ background: "#4f46e5", top: "35%" }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="path_b"
        style={{ background: "#7c3aed", top: "65%" }}
      />

      {/* Labels next to handles */}
      <div style={{
        position: "absolute", right: -38, top: "29%",
        fontSize: 9, color: "#4f46e5", fontWeight: 700,
      }}>A</div>
      <div style={{
        position: "absolute", right: -38, top: "59%",
        fontSize: 9, color: "#7c3aed", fontWeight: 700,
      }}>B</div>
    </div>
  );
};

export default ABSplitNode;
